import { NgModule } from '@angular/core';

/**
 * Used as a placeholder for the code generator. Do not delete.
 */
@NgModule({
})
export class CommonModule { }
